import { render, staticRenderFns } from "./ShipBluPrompt.vue?vue&type=template&id=797de31b&lang=html"
import script from "./ShipBluPrompt.vue?vue&type=script&lang=js"
export * from "./ShipBluPrompt.vue?vue&type=script&lang=js"
import style0 from "./ShipBluPrompt.vue?vue&type=style&index=0&id=797de31b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports